/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/uploadFile/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { Button } from 'antd'
import React, { ChangeEvent, ReactNode, useEffect, useRef, useState } from 'react'
import Icons from '../Icons'

type Props = {
  label: ReactNode
  onChange: (file: ChangeEvent<HTMLInputElement>) => void
  hidden?: boolean
  key?: string
  className?: string
  styles?: React.CSSProperties
}

const UploadFile: React.FC<Props> = (props) => {
  const { label = '', onChange, hidden = false, key, className, styles } = props

  const refFile = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    refFile.current.value = null
    refFile.current.click()
  }

  useEffect(() => {
    if (label === undefined) {
      setLoading(true)
    } else {
      setLoading(false)
    }
  }, [label])

  return (
    <>
      <Button
        style={styles}
        className={className}
        key={key}
        hidden={hidden}
        onClick={handleClick}
        type='default'
      >
        {loading ? <Icons icon={faSpinner} spin /> : label}
      </Button>
      <input key={key} hidden ref={refFile} type='file' accept='.kml' onChange={onChange} />
    </>
  )
}
export default UploadFile
